// app/javascript/controllers/apex_chart_controller.js
import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = {
    data: Object
  }

  connect() {
    this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  renderChart() {
    const points = this.dataValue.points || []

    // Préparer les données pour ApexCharts
    const series = [{
      name: 'Valeur',
      data: points.map(point => ({
        x: new Date(point.x).getTime(),
        y: point.y.value
      }))
    }]

    const options = {
      series: series,
      chart: {
        type: 'area',
        height: 450,
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        },
        locales: [{
          name: 'fr',
          options: {
            months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            shortMonths: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
            days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
            shortDays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
          }
        }],
        defaultLocale: 'fr'
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 3,
        curve: 'smooth'
      },
      colors: ['#5076F6'],
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.6,
          stops: [30, 100]
        }
      },
      xaxis: {
        type: 'datetime',
        labels: {
          format: 'MMM yyyy',
          style: {
            fontSize: '14px'
          }
        }
      },
      yaxis: {
        title: {
          text: 'Prix / m²',
          style: {
            color: '#5076F6',
            fontSize: '14px'
          }
        },
        labels: {
          formatter: (value) => {
            return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €'
          },
          style: {
            fontSize: '14px'
          }
        }
      },
      tooltip: {
        shared: true,
        intersect: false,
        x: {
          format: 'MMM yyyy'
        },
        y: {
          formatter: (value) => {
            return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €'
          }
        }
      },
      legend: {
        show: false
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}
